export default (theme) => ({
  root: {
    flexGrow: 0,
    width: 'calc(100% - 80px)',
    margin: '20px 40px 0',
    marginBottom: 'auto',
    background: '#FDF3F1',
    boxShadow:
      '0 1px 2px 0 rgba(0,0,0,0.05), inset 0 0 0 1px rgba(246,161,148,0.40)',
    borderRadius: 7,
    fontSize: 14,
    color: theme.palette.text.error,

    '& a': {
      color: theme.palette.text.error,
      textDecoration: 'underline',
    },

    '& p': {
      margin: '4px 0px',
    },

    '& strong': {
      fontWeight: 500,
    },
  },

  section: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '8px 20px 8px 15px',
    borderTop: `1px solid rgba(246,161,148,0.40)`,
    '&:first-child': {
      borderTop: 'none',
    },
  },

  content: {
    alignSelf: 'flex-start',
  },

  title: {
    fontWeight: 500,
    fontSize: 15,
    color: theme.palette.text.errorHeading,
  },

  icon: {
    alignSelf: 'center',
    marginRight: 10,
    width: 26,
    height: 26,
  },

  inline: {
    width: '100%',
    margin: '0 0 20px',
  },

  actions: {
    marginTop: 8,
    marginBottom: 'auto',
    marginLeft: 'auto',
    paddingLeft: 20,
  },

  refetch: {
    marginLeft: 20,
  },

  loadingIndicator: {
    width: '20px !important',
    height: '20px !important',
    position: 'relative',
    top: 6,
    '& svg': {
      width: 20,
      height: 20,
      color: 'rgb(246,161,148)',
    },
  },

  errorBacktrace: {
    paddingLeft: 20,
    marginBottom: 5,
    marginTop: 0,
  },

  badge: {
    whiteSpace: 'pre',
    border: `1px solid rgba(246,161,148,0.40)`,
    textTransform: 'uppercase',
    fontWeight: 500,
    padding: '3px 10px',
    borderRadius: 7,
    fontSize: 13,
  },
});
